import React, { Component } from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import ResultsInnerExperienceUser from './ResultsInnerExperienceUser'
import WishlistButton from './WishlistButton'
import shortid from 'shortid'
import object_value from '../api/object_value'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'
import prepare_rating from '../api/prepare_rating'
import { user_by_id } from '../api'

@inject('user')
@observer
class ResultsInnerExperience extends Component {
  constructor (props) {
    super(props)
    const { experience, user, show_user } = props

    if (show_user) {
      // userById.get(experience.user_id.toString())
    }

    this.state = {
      image_style: {
        backgroundImage: 'url(' + experience.image_url + ')'
      },
      experience_user: {
        data: {},
        loaded: false
      }
    }

    let location = object_value(experience, 'location', '')
    let city = object_value(experience, 'city.name')
    this.experience_location = city
      ? location + ', ' + city
      : location
  }

  componentDidMount() {
    const { show_user, experience } = this.props
    console.log('ResultsInnerExperience.js - render() - experience', experience)

    if (show_user) {
      user_by_id(experience.user_id).then(data => {
        console.log('user_by_id', data)
        this.setState({
          experience_user: {
            ...this.state.experience_user,
            data,
            loaded: true
          }
        })
      })
    }
  }

  render () {
    const {
      userById,
      experience,
      variant,
      topic,
      date,
      is_before,
      is_today,
      is_after,
      show_liked,
      show_user,
      show_rating,
      show_price,
      show_table,
      show_guests,
      show_date,
      date_label,
      hide_expired_date
    } = this.props
    const { image_style } = this.state

    if (!experience) {
      return (<div />)
    }

    let should_show_date = () => {
      if (!show_date) {
        return false
      }

      if (!hide_expired_date) {
        return true
      }

      return !is_before
    }

    return (
      <div className={'b-experiences-experience ' + variant}>
        {topic &&
        <div className='b-experiences-experience-topic'>
          {topic}
        </div>}

        <NavLink to={'/experience/' + experience.id}
                 className='b-experiences-experience-image'
                 style={image_style}>
          {show_liked &&
          <WishlistButton experience_id={experience.id.toString()} />}
        </NavLink>

        {show_user &&
        <ResultsInnerExperienceUser experience_user={this.state.experience_user} />}

        <NavLink to={'/experience/' + experience.id}
              className='b-experiences-experience-title'>
          {experience.title}
        </NavLink>
        <div className='b-experiences-experience-description'>
          {experience.description}
        </div>

        {show_rating &&
        <div className='b-experiences-experience-rating'>
          <div className='b-experiences-experience-rating-stars'
               data-rating={prepare_rating(experience.rating_average)}>
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
          <span>
            {experience.rating_amount} {intl.get('experiences.reviews')}</span>
        </div>}

        {show_price &&
        <div className='b-experiences-experience-price'>€ {experience.price}</div>}

        {show_table && <hr key={shortid.generate()} />}

        {show_table &&
        <div key={shortid.generate()} className='b-experiences-experience-table'>
          <div className='b-experiences-experience-table-label'>Ort</div>
          <div className='b-experiences-experience-table-value'>
            {this.experience_location}
          </div>
        </div>}

        {show_table && should_show_date() &&
        <div key={shortid.generate()} className='b-experiences-experience-table'>
          <div className='b-experiences-experience-table-label'>{date_label}</div>
          <div className='b-experiences-experience-table-value'>{date}</div>
        </div>}

        {show_table && show_guests &&
        <div key={shortid.generate()} className='b-experiences-experience-table'>
          <div className='b-experiences-experience-table-label'>{intl.get('Guests')}</div>
          <div className='b-experiences-experience-table-value'>{experience.bookings_count}</div>
        </div>}

        {(experience.activated === "undefined" || !experience.activated) &&
        <div key={shortid.generate()} className='b-message b-message_warning'>
          {intl.get('experiences.created_but_not_activated')}
        </div>}
      </div>
    )
  }
}

ResultsInnerExperience.defaultProps = {
  variant: '',
  topic: '',
  date: '',
  is_before: false,
  is_today: false,
  is_after: false,
  show_liked: true,
  show_user: false,
  show_rating: true,
  show_price: true,
  show_table: false,
  show_guests: false,
  show_date: true,
  date_label: 'Date',
  hide_expired_date: false
}

// TODO: Rewrite data to be the correct types
const numberOrString = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
])

ResultsInnerExperience.propTypes = {
  userById: MobxPropTypes.observableObject,
  experience: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    image_url: PropTypes.string,
    // rating: numberOrString,
    description: PropTypes.string,
    // reviews: PropTypes.string,
    price: numberOrString
  }).isRequired,
  experience_user: PropTypes.object,
  variant: PropTypes.string,
  topic: PropTypes.string,
  date: PropTypes.string,
  is_before: PropTypes.bool,
  is_today: PropTypes.bool,
  is_after: PropTypes.bool,
  show_liked: PropTypes.bool,
  show_user: PropTypes.bool,
  show_rating: PropTypes.bool,
  show_price: PropTypes.bool,
  show_table: PropTypes.bool,
  show_guests: PropTypes.bool,
  show_date: PropTypes.bool,
  date_label: PropTypes.string,
  hide_expired_date: PropTypes.bool
}

export default ResultsInnerExperience


// WEBPACK FOOTER //
// ./src/components/ResultsInnerExperience.js